import { get, toLower } from "lodash"
import PropTypes from "prop-types"
import classNames from "classnames"
import { ShoppingBasket, Gradient, Dns, Work } from "@mui/icons-material"

import "./styles.scss"

function getIcon(type) {
  switch (toLower(type)) {
    case "portfolio":
      return <Work />
    case "topic":
      return <Gradient />
    case "watchlist":
      return <Dns />
    case "basket":
    case "swap":
      return <ShoppingBasket />
  }
  return null
}

export default function ResourceIcon({ type, ...props }) {
  const displayType = type === "swap" ? "basket" : type

  return <div {...props} className={classNames("component_resource-icon", get(props, "className", ""), displayType)}>
    {getIcon(type)}
    <div className="resource-type-label">{displayType}</div>
  </div>
}

ResourceIcon.propTypes = {
  type: PropTypes.oneOf(["portfolio", "basket", "swap", "topic", "watchlist"]).isRequired,
}
